import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Updates from './components/Updates';
import About from './components/About';
import Ranking from './components/Ranking';
import Cards from './components/Cards';
import Index from './components/Index';
import Topics from './components/Topics';
import AppSection from './components/AppSection';
import Media from './components/Media';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Carousel from './components/Carousel';
import Comments from './components/Comments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Updates />
        <About />
        <Ranking />
        <Cards />
        <Index />
        <Topics />
        <AppSection />
        <Media />
        <FAQ />
        <Contact />
        <Carousel />
        <Comments />
      </main>
      <Footer />
    </div>
  );
}